/** 48×48 viewBox — kenarlara yakın, dolu marka görünümü */
export const OPAS_BRAND_MARK_COLOR = '#C1272D'
export const OPAS_BRAND_MARK_SVG_PATH = 'M4 4h40v40H4V4zm11 11h18v18H15V15z'
export const OPAS_BRAND_MARK_ROTATE_DEG = 12

/**
 * Uygulama simgesi zemini. ImageResponse şeffaf PNG'yi her ortamda vermez; beyaz zemin
 * logoyu pul gibi gösterir. Manifest `background_color` ile aynı tutulur.
 */
export const OPAS_APP_ICON_BACKGROUND = '#0f172a'

/**
 * SuperAdmin marka rengi — amber. Merkez bildirimleri eczane bildirimlerinden bu renkle ayrılır.
 * Aynı ton arayüzde `superadminChrome.getSaBrandMarkColor` ile kullanılır; burada ayrı durur
 * çünkü görsel üreten route'lar tema katmanını (MUI) yüklemez.
 */
export const OPAS_SA_BRAND_MARK_COLOR = '#f59e0b'

/**
 * Medopas marka rengi — yeşil. `(medopas)/icon.svg` ve MUI success.main ile aynı.
 * Kurulu Medopas penceresinin şeridi ve simgesi bu tondadır.
 */
export const OPAS_MEDOPAS_BRAND_MARK_COLOR = '#2e7d32'
